module.exports = __webpack_public_path__ + "img/carshina22_04.c8fff7b3.jpg";